
<template>
    <InvoicesContainer
        :project="selectedProject"
        :year="selectedYear"
        :yearOptions="yearOptions"
    />
</template>

<script>
import store from '@/store'
import InvoicesContainer from '@/modules/Invoices'
import InvoicesStore from '@/modules/Invoices/_store'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
import useSelectYear from '@/composables/useSelectYear'
import { getCurrentInstance } from '@vue/composition-api'
const STORE_KEY = '$_invoice'

export default {
    components: {
        InvoicesContainer
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const {
            selectedProject,
            setInitialAccountSelect
        } = useSelectProjectAndGroup()
        const {
            yearModel,
            yearOptions,
            selectedYear,
            setInitialYearSelect
        } = useSelectYear(STORE_KEY)

        if (!selectedProject.value) {
            setInitialAccountSelect()
        }

        store.dispatch(`${STORE_KEY}/getInvoiceMonths`, { usageAccountId: selectedProject.value.usageAccountId }).then(({ data }) => {
            if (data) {
                const year = data.length && data[0].substring(0, 4)
                setInitialYearSelect()
                store.dispatch(`${STORE_KEY}/getInvoiceAnnualSummary`, { usageAccountId: selectedProject.value.usageAccountId, year })
            }
        })
        return {
            selectedProject,
            yearModel,
            selectedYear,
            yearOptions
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, InvoicesStore)
        }
        next()
    }
}
</script>

<style>

</style>
